export default class extends Controller {
  static targets = ['moreContainer'];

  connect() {
    this.loadMore = this.loadMore.bind(this);
    window.addEventListener('scroll', this.loadMore);
  }

  disconnect() {
    window.removeEventListener('scroll', this.loadMore);
  }

  loadMore() {
    if (this.moreURL && !this.loading && this.shouldLoadMore) {
      this.loading = true;
      this.appendSpinner();
      App.Helpers.ajaxRequest({ url: this.moreURL, successHandler: this.updateContent.bind(this) });
    }
  }

  updateContent(response) {
    this.moreURL = response.moreURL;
    App.Helpers.appendContent(this.moreContainer, response.html);
    this.removeSpinner();
    this.loading = false;
  }

  appendSpinner() {
    App.Helpers.appendContent(this.element, App.spinner());
  }

  removeSpinner() {
    this.element.querySelector('.js-spinner').remove();
  }

  //
  // GETTERS AND SETTERS
  //

  get moreURL() {
    return this.data.get('more-url');
  }

  set moreURL(newURL) {
    this.data.set('more-url', newURL);
  }

  get loading() {
    return this.data.get('loading');
  }

  set loading(isLoading) {
    this.data.set('loading', isLoading ? '1' : '');
  }

  get shouldLoadMore() {
    return App.Helpers.scrollPixelsRemaining() <= 100;
  }

  get moreContainer() {
    return this.moreContainerTarget || this.element;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/infinite-scroll-controller.js